"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-arrow-right", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M9.418 16.726v3.933l12.743-5.921L9.418 9.606v3.934H.494v3.186h8.924z", fill: "#4C4C4C" }),
            _react2.default.createElement("path", { d: "M15 29C7.268 29 1 22.732 1 15S7.268 1 15 1s14 6.268 14 14-6.268 14-14 14zm0 1c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z", fill: "#BBB", fillRule: "nonzero" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-arrow-right.js
// module id = 1874
// module chunks = 0